<kg-movie-overlay
  [poster]="movie.posters![0]"
  [isOrderPage]="true"
  [style.display]="screening.screen?.branding?.backgroundColor ? 'none' : null"
></kg-movie-overlay>
<div
  class="content content-relative"
  [class.sticky-summary-visible]="orderTickets.length"
  [class.has-branding-background]="!!screening.screen?.branding?.backgroundColor"
  [style.background-color]="screening.screen?.branding?.backgroundColor || null"
>
  <div class="container container-xl container-relative">
    <div class="breadcrumbs-wrapper">
      <kg-breadcrumbs [breadcrumbs]="breadcrumbs"></kg-breadcrumbs>
      <div class="hidden-mobile timer-wrapper-web">
        <kg-reservation-timer></kg-reservation-timer>
      </div>
    </div>
    <div class="payment-alert hidden-mobile">
      <ng-container [ngTemplateOutlet]="paymentStartedTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="screeningStartedTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="screeningTimeExceededTemplate"></ng-container>
    </div>

    <div class="reservation-wrapper">
      <div class="reservation">
        <div class="reservation-screening-panel">
          <kg-reservation-info-card
            [hideVideoMobile]="true"
            [showMobile]="true"
            [showDetails]="false"
            [screening]="screening"
          >
            <kg-screening-select
              [disabled]="!!paymentId || !canBuyTicket"
              screening-select
              [options]="movieScreeningList"
              [selectedOption]="currentMovieScreening"
              (onChange)="onScreeningSelect($event)"
            ></kg-screening-select>
          </kg-reservation-info-card>
        </div>
        <div
          class="reservation-places-panel"
          [style.background-color]="screening.screen?.branding?.sectionBackgroundColor"
          [style.border-color]="screening.screen?.branding?.sectionBorderColor"
        >
          <img
            *ngIf="isPartnerScreenRoom"
            class="partner"
            src="/assets/img/partners/logo-caffe-vergnano.png"
            alt="Sala by Caffe Vergnano"
          />

          <div class="hidden-web">
            <ng-container [ngTemplateOutlet]="paymentStartedTemplate"></ng-container>
            <ng-container [ngTemplateOutlet]="screeningStartedTemplate"></ng-container>
            <ng-container [ngTemplateOutlet]="screeningTimeExceededTemplate"></ng-container>
          </div>

          <div class="trailer-wrapper">
            <kg-auto-trailer
              *ngIf="screening.movie.trailers?.length"
              [videoId]="Utils.getVideoIdFromUrl(screening.movie!.trailers![0])"
              [tagGroups]="screening.movie.tagGroups!"
            ></kg-auto-trailer>
          </div>

          <kg-seat-grid
            class="content-relative"
            [screen]="screening.screen!"
            [screenId]="screening.screenId"
            [screeningId]="screening.id"
            [buyTimeExceeded]="!canBuyTicket"
            (selectedSeat)="onSeatSelect($event)"
          ></kg-seat-grid>

          <kg-tape
            [hidden]="isPartnerScreenRoom"
            [type]="TapeType.MOVIE"
            img="tape-movie"
            [imageUrl]="screening.screen?.branding?.backgroundImageUrl || null"
          ></kg-tape>
        </div>
      </div>
      <kg-mobile-branding-slider
        class="hidden-web"
        *ngIf="screening.screen?.branding?.sliderEnabled && screening.screen?.branding?.sliderImageUrls?.length"
        [images]="screening.screen?.branding?.sliderImageUrls || []"
      ></kg-mobile-branding-slider>
      <div class="reservation-tickets-panel">
        <kg-tickets
          (onSelect)="onTicketSelect($event)"
          (onApplyVoucher)="onApplyVoucher($event)"
          (onRemoveVoucher)="onRemoveVoucher($event)"
          [voucher]="voucherFromUrl"
          [textColor]="screening.screen?.branding?.textColor || null"
          [topImageUrl]="screening.screen?.branding?.rightSectionTopImageUrl || null"
          [bottomImageUrl]="screening.screen?.branding?.rightSectionBottomImageUrl || null"
          [cardBorderColor]="screening.screen?.branding?.sectionBorderColor || null"
          [sectionBackgroundColor]="screening.screen?.branding?.sectionBackgroundColor || null"
          [sliderEnabled]="screening.screen?.branding?.sliderEnabled || false"
          [sliderImageUrls]="screening.screen?.branding?.sliderImageUrls || []"
        ></kg-tickets>
        <kg-sticky-summary
          [orderTickets]="orderTickets"
          [title]="'Reservation.GoNext'"
          [textColor]="screening.screen?.branding?.textColor || null"
          [ctaColor]="screening.screen?.branding?.ctaColor || null"
          (onButtonClick)="goToNextStep()"
        ></kg-sticky-summary>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentStartedTemplate>
  <kg-alert
    *ngIf="paymentId"
    class="payment-started-alert"
    [message]="'Payment.PaymentStarted' | translate"
    [type]="AlertType.Warning"
  ></kg-alert>
</ng-template>

<ng-template #screeningStartedTemplate>
  <kg-alert
    *ngIf="canBuyTicket && showCanBuyTicketAlert"
    [type]="AlertType.Warning"
    message="{{ 'Screening.ScreeningHasStartedButCanBuy' | translate }}"
  ></kg-alert>
</ng-template>

<ng-template #screeningTimeExceededTemplate>
  <kg-alert
    *ngIf="!canBuyTicket"
    [type]="AlertType.Error"
    message="{{ 'Screening.ScreeningHasStartedButCantBuy' | translate }}"
  ></kg-alert>
</ng-template>
